module.exports = __webpack_public_path__ + "static/media/deleteEnable.ad47bb37.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/deleteEnable.png
// module id = 202
// module chunks = 0